import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./i18n";
import App from "./layout/App";
import Wrapper from "./layout/Wrapper";
import mockBackend from "./mock/backend";
import { BrowserRouter } from "react-router-dom";
import backendConfig from "./mock/backend.config";
import { configureFetch, POST } from "./utils/fetchUtil";

import {
  isAuthenticated,
  getReturnUrl,
  signOut,
  login,
  processLoginCallback,
  processLogoutCallback,
} from "./common/authorization/AuthorizeService";
import {
  QueryParameterNames,
  LoginActions,
  AuthorizationPaths,
} from "./common/authorization/ApiAuthorizationConstants";
import { faPowerOff } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Message } from "./common/message";

if (
  /* process.env.NODE_ENV === "development" || */ process.env.REACT_APP_FORCE_MOCK_BACKEND ===
  "true"
) {
  mockBackend(backendConfig);
  console.warn("Using mocked backend. No real HTTP calls will be fired.");
  console.info(process.env);
} else {
  configureFetch({
    gatewayUrl: process.env.REACT_APP_GATEWAY_URL,
    defaultFetchOptions: {
      mode: "cors",
      credentials: "include",
    },
  });
}

isAuth();

async function isAuth() {
  const value = await isAuthenticated();
  if (value === false) {
    const path = window.location.pathname;
    const url = window.location.href;

    switch (path) {
      case AuthorizationPaths.Login:
      case "/":
        await login(getReturnUrl());
        break;
      case AuthorizationPaths.LoginCallback:
        await processLoginCallback();
        break;
      case AuthorizationPaths.LoginFailed:
        const params = new URLSearchParams(window.location.search);
        const error = params.get(QueryParameterNames.Message);
        break;
      case AuthorizationPaths.LogOutCallback:
        processLogoutCallback();
        break;
      default:
        await login(getReturnUrl());
        break;
    }
  } else {
    POST(
      process.env.REACT_APP_LOGIN_URL,
      null,
      (user) =>
        ReactDOM.render(
          <Suspense fallback={<>...</>}>
            <Wrapper app={App} router={BrowserRouter} user={user} />
          </Suspense>,
          document.getElementById("root")
        ),
      (error) => {
        if (error === 403) {
          ReactDOM.render(
            <div>
              <Message
                show={true}
                title={"Upozorenje"}
                content={"Nemate prava za tražene akcije."}
                onYes={() => {
                  signOut(getReturnUrl());
                  /* .then((user) => this.onRedirectSuccess(user))
                    .catch((error) => this.onRedirectError(error)); */
                }}
                yesLabel={
                  <div>
                    <FontAwesomeIcon icon={faPowerOff} size={"1x"} />
                    <span> Odjava</span>
                  </div>
                }
                hideYes={false}
                hideNo={true}
                hideX={false}
                isWait={false}
              />
            </div>,
            document.getElementById("root")
          );
        }
        if (error === 401) {
          signOut(getReturnUrl());
          /* .then((user) => this.onRedirectSuccess(user))
            .catch((error) => this.onRedirectError(error)); */
        }
      }
    );
  }
}
